export default function TermsAndConditions() {
  return (
    <div style={{ background: '#0a0a0a', minHeight: '100vh', fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif", color: '#ffffff', padding: '40px 20px' }}>
      <div style={{ maxWidth: '680px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '32px', borderBottom: '1px solid #2a2a2a' }}>
          <div style={{ fontSize: '28px', fontWeight: '900', letterSpacing: '.15em', textTransform: 'uppercase' }}>WOW FACTOR</div>
          <div style={{ fontSize: '11px', color: '#555', letterSpacing: '.2em', textTransform: 'uppercase', marginTop: '4px' }}>Baseball Training &amp; Development</div>
        </div>

        <h1 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>Terms &amp; Conditions</h1>
        <p style={{ color: '#666', fontSize: '13px', marginBottom: '32px' }}>Effective date: April 21, 2026</p>

        <Section title="1. Acceptance of Terms">
          By creating an account and using the Wow Factor Baseball platform (&ldquo;the Platform&rdquo;), you agree to be bound by these Terms &amp; Conditions. If you do not agree, please do not use the Platform.
        </Section>

        <Section title="2. Eligibility">
          You must be at least 18 years old to create an account. By registering, you confirm that all information you provide is accurate and complete.
        </Section>

        <Section title="3. Account Responsibilities">
          You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. Wow Factor Baseball is not liable for any loss resulting from unauthorized account access.
        </Section>

        <Section title="4. Session Booking">
          <p style={{ marginBottom: '10px' }}>Sessions are requested through the Platform and are not confirmed until an instructor approves the booking. You will receive a confirmation notification once your session is confirmed.</p>
          <p>Session availability is set by individual instructors and is subject to change. Wow Factor Baseball does not guarantee the availability of any specific instructor or time slot.</p>
        </Section>

        <Section title="5. Cancellation Policy">
          <p style={{ marginBottom: '10px' }}>We ask that you cancel at least <strong style={{ color: '#ffffff' }}>24 hours in advance</strong> if you are unable to attend a session. Last-minute cancellations and no-shows impact instructors&rsquo; schedules and income.</p>
          <p>Repeated no-shows or late cancellations may result in account suspension at the discretion of Wow Factor Baseball.</p>
        </Section>

        <Section title="6. Payment">
          <p style={{ marginBottom: '10px' }}>Payment for sessions is handled directly between the parent and the instructor via CashApp. The Platform does not process or hold payments on your behalf.</p>
          <p>Wow Factor Baseball is not responsible for any payment disputes between parents and instructors. All payment arrangements are between the parties involved.</p>
        </Section>

        <Section title="7. Code of Conduct">
          All users — parents, players, and instructors — agree to interact with respect and professionalism. Harassment, abusive language, or inappropriate behavior toward any user may result in immediate account termination.
        </Section>

        <Section title="8. Instructor Independence">
          Instructors on the Platform are independent individuals, not employees of Wow Factor Baseball. Wow Factor Baseball does not supervise, control, or guarantee the quality of training sessions provided by instructors.
        </Section>

        <Section title="9. Limitation of Liability">
          Wow Factor Baseball provides the Platform on an &ldquo;as is&rdquo; basis. To the fullest extent permitted by law, Wow Factor Baseball shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Platform, including but not limited to injuries sustained during training sessions, payment disputes, or data loss.
        </Section>

        <Section title="10. Account Termination">
          Wow Factor Baseball reserves the right to suspend or terminate any account at any time for violation of these Terms, fraudulent activity, or conduct deemed harmful to the Platform or its users.
        </Section>

        <Section title="11. Changes to These Terms">
          We may update these Terms from time to time. Continued use of the Platform after changes are posted constitutes your acceptance of the revised Terms. The effective date at the top of this page will reflect the most recent update.
        </Section>

        <Section title="12. Contact Us">
          Questions about these Terms? Contact us at{' '}
          <a href="mailto:support@wowfactortraining.com" style={{ color: '#60a5fa' }}>support@wowfactortraining.com</a>.
        </Section>

        <div style={{ borderTop: '1px solid #1e1e1e', marginTop: '40px', paddingTop: '24px', textAlign: 'center' }}>
          <p style={{ color: '#444', fontSize: '12px', margin: 0 }}>
            <a href="/register" style={{ color: '#60a5fa', textDecoration: 'none' }}>Back to Registration</a>
            {' · '}
            <a href="/privacy" style={{ color: '#60a5fa', textDecoration: 'none' }}>Privacy Policy</a>
            {' · '}
            <a href="/login" style={{ color: '#60a5fa', textDecoration: 'none' }}>Sign In</a>
          </p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '28px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '10px', color: '#ffffff' }}>{title}</h2>
      <div style={{ color: '#a0a0a0', fontSize: '14px', lineHeight: '1.7' }}>{children}</div>
    </div>
  );
}
